var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedWithWhiteCircleGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8074)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8074",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.0234C38.2678 49.0234 49.0234 38.2678 49.0234 25C49.0234 11.7322 38.2678 0.976562 25 0.976562C11.7322 0.976562 0.976562 11.7322 0.976562 25C0.976562 38.2678 11.7322 49.0234 25 49.0234Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 41.0156C33.8452 41.0156 41.0156 33.8452 41.0156 25C41.0156 16.1548 33.8452 8.98438 25 8.98438C16.1548 8.98438 8.98438 16.1548 8.98438 25C8.98438 33.8452 16.1548 41.0156 25 41.0156Z",
    fill: "#4CB537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5196 17.6879C35.3012 17.4675 35.0413 17.2925 34.7549 17.1731C34.4685 17.0537 34.1612 16.9922 33.8509 16.9922C33.5406 16.9922 33.2334 17.0537 32.947 17.1731C32.6605 17.2925 32.4006 17.4675 32.1822 17.6879L22.0496 27.8843L17.8178 23.6265C17.5994 23.4061 17.3394 23.2311 17.053 23.1117C16.7666 22.9922 16.4594 22.9308 16.1491 22.9308C15.8388 22.9308 15.5315 22.9922 15.2451 23.1117C14.9587 23.2311 14.6988 23.4061 14.4804 23.6265C14.0375 24.0733 13.7891 24.6768 13.7891 25.3059C13.7891 25.9349 14.0375 26.5385 14.4804 26.9853L20.3807 32.9236C20.599 33.1441 20.8589 33.3191 21.1453 33.4386C21.4318 33.5581 21.739 33.6196 22.0494 33.6196C22.3597 33.6196 22.667 33.5581 22.9534 33.4386C23.2398 33.3191 23.4997 33.1441 23.7181 32.9236L35.5196 21.0467C35.9625 20.6 36.211 19.9964 36.211 19.3673C36.211 18.7383 35.9625 18.1347 35.5196 17.6879Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedWithWhiteCircleGreen);
export default __webpack_public_path__ + "static/media/verified_with_white_circle_green.ae7a4175999852fef33327f9190d0075.svg";
export { ForwardRef as ReactComponent };